import { Injectable } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { UrlValidator } from "@atenea-cms";
import { EsportsSlide } from "./esports-slide.model";

@Injectable()
export class EsportsSlideFormService {
  constructor(private fb: FormBuilder) {}

  getForm(esportsSlide: EsportsSlide = new EsportsSlide()): FormGroup {
    return this.fb.group({
      _id: [esportsSlide._id],
      name: [esportsSlide.name, Validators.required],
      image: [esportsSlide.image],
      background: [esportsSlide.background],
      title: [esportsSlide.title],
      url: [esportsSlide.url, UrlValidator],
      content: [esportsSlide.content],
      mode: [esportsSlide.mode],
      position: [esportsSlide.position],
      active: [esportsSlide.active],
      slug: [esportsSlide.slug],
      bgDesktop: [esportsSlide.bgDesktop],
      bgMobile: [esportsSlide.bgMobile],
      contentAlign: [esportsSlide.contentAlign],
    });
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/esports-slides/shared/esports-slide-form.service.ts